<template>
    <div class="local-preloader">
        <div class="lds-dual-ring" :class="{'lds-dual-ring__mini': mini}"></div>
    </div>
</template>

<script>
export default {
    props: {
        mini: {
            type: Boolean,
            default: false
        }
    }
}
</script>